import React, { useState, useEffect } from 'react';
import './ResultPanel.css';


function ResultPanel({ detectedSign, sentence, onClearSentence, onAddToSentence }) {
  const [prevSign, setPrevSign] = useState(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (detectedSign && detectedSign.letter !== prevSign?.letter) {
      setAnimate(true);
      setPrevSign(detectedSign);
      const t = setTimeout(() => setAnimate(false), 400);
      return () => clearTimeout(t);
    }
  }, [detectedSign, prevSign]);

  const sentenceText = sentence.join(' ');

  return (
    <div className="result-panel">
      {/* Current Detection */}
      <div className="result-card detected-card">
        <div className="card-label">DETECTED SIGN</div>
        <div className={`sign-display ${animate ? 'pop' : ''}`}>
          {detectedSign ? (
            <>
              <div className="sign-letter">{detectedSign.letter}</div>
              <div className="sign-description">{detectedSign.description}</div>
              {detectedSign.confidence > 0 && (
                <div className="confidence-bar">
                  <div className="conf-label">
                    <span>Confidence</span>
                    <span>{Math.round(detectedSign.confidence * 100)}%</span>
                  </div>
                  <div className="conf-track">
                    <div
                      className="conf-fill"
                      style={{ width: `${detectedSign.confidence * 100}%` }}
                    />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="no-sign">
              <div className="no-sign-icon">🖐</div>
              <p>Waiting for gesture...</p>
            </div>
          )}
        </div>
      </div>

      {/* Sentence Builder */}
      <div className="result-card sentence-card">
        <div className="card-label">
          SENTENCE BUILDER
          <button
            className="clear-btn"
            onClick={onClearSentence}
            disabled={sentence.length === 0}
          >
            Clear
          </button>
        </div>
        <div className="sentence-display">
          {sentence.length > 0 ? (
            <>
              <div className="sentence-text">{sentenceText}</div>
              <div className="sentence-chars">
                {sentence.map((char, i) => (
                  <span key={i} className="char-bubble">{char}</span>
                ))}
              </div>
            </>
          ) : (
            <div className="sentence-empty">
              <p>Signs you add will appear here</p>
              <span>Use the button below to add current sign</span>
            </div>
          )}
        </div>
        <button
          className="add-btn"
          onClick={() => detectedSign && detectedSign.confidence > 0.5 &&
            onAddToSentence(detectedSign.letter)}
          disabled={!detectedSign || detectedSign.confidence < 0.5}
        >
          + Add to Sentence
        </button>
      </div>

      {/* Quick Reference */}
      <div className="result-card quick-ref">
        <div className="card-label">QUICK REFERENCE</div>
        <div className="ref-grid">
          {[
            { sign: '✋', label: 'Hello' },
            { sign: '👍', label: 'Yes' },
            { sign: '👎', label: 'No' },
            { sign: '🤟', label: 'ILY' },
            { sign: '✌️', label: 'Peace' },
            { sign: '☝️', label: 'Point' },
            { sign: '🤙', label: 'Call' },
            { sign: '👌', label: 'OK' },
          ].map(({ sign, label }) => (
            <div key={label} className="ref-item">
              <span className="ref-emoji">{sign}</span>
              <span className="ref-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ResultPanel;
